// Napkins Product Functionality
console.log('Product Napkins JS loaded');
console.log('Body classes:', document.body.className);

class NapkinsProduct {
    constructor() {
    console.log('NapkinsProduct initialized');
    
    // State
    this.selectedSize = 'Cocktail 25x25cm';
    this.selectedPrintType = 'Simple';
    this.selectedQuantity = 250;
    this.isRushed = false;
    this.currentUnitPrice = 0;
    
    // Constants
      this.UNITS_PER_CARTON = 1000;
    this.RUSH_MULTIPLIER = 1.3; // 30% surcharge
    
    // Full Colour Print is not available for napkins
    this.fullColourSizes = []; // No sizes support full colour for napkins
    
    // Pricing will be loaded dynamically from Shopify variants
    this.pricingData = null;
    this.productData = null;
      
    // Variant mapping for quantity-based pricing
    // Real variant IDs from Shopify admin (updated to match napkin product)
    this.variantMapping = {
      "Cocktail 25x25cm_Simple": {
        "250": "50731332895002",
        "500": "50731332927770",
        "1000": "50731332960538",
        "2000": "50731332993306",
        "3000": "50731333026074",
        "4000": "50731333058842",
        "5000": "50731333091610"
      },
      "2-Ply Folded Napkin 10x20cm_Simple": {
        "250": "50731394990362",
        "500": "50731395023130",
        "1000": "50731395055898",
        "2000": "50731395088666",
        "3000": "50731395121434",
        "4000": "50731395154202",
        "5000": "50731395186970"
      }
    };
      
      this.init();
    }

    init() {
    this.setupSizeSelector();
    this.setupPrintTypeSelector();
    this.setupTurnaroundSelector();
    this.setupFormSubmission();
    this.setupFileUpload();
    this.setupShippingCalculator();
    this.setupDynamicDescription();
    this.setupTooltips();
    this.updatePrintTypeAvailability();
    this.updatePricingTable();
    this.checkCartAddSuccess();
    this.preventAutoScroll();
  }
  
  setupSizeSelector() {
    const sizeButtons = document.querySelectorAll('.size-btn');
    console.log('Setting up size selector, found buttons:', sizeButtons.length);
    
    sizeButtons.forEach((btn, index) => {
      btn.addEventListener('click', () => {
        console.log('Size button clicked:', btn.dataset.size);
        
        // Update selection
        sizeButtons.forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');
        
        this.selectedSize = btn.dataset.size;
        console.log('Size selected:', this.selectedSize);
        
        this.updatePrintTypeAvailability();
        this.updatePricingTable();
        this.updateDynamicDescription();
        this.updateMediaGalleryForSelectedVariant();
      });
    });
  }
  
  setupPrintTypeSelector() {
    const printButtons = document.querySelectorAll('.print-type-btn');
    console.log('[PrintType Debug] Setting up print type selector, found buttons:', printButtons.length);
    
    printButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.classList.contains('disabled')) {
          // Show popup if Full Colour is clicked while disabled
          if (btn.dataset.printType === 'FullColour') {
            this.showFullColourIncompatibilityPopup();
          }
          return;
        }
        
        // Update selection
        printButtons.forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');
        
        this.selectedPrintType = btn.dataset.printType;
        console.log('Print type selected:', this.selectedPrintType);
        
        this.updatePricingTable();
        this.updateMediaGalleryForSelectedVariant();
      });
    });

    // Setup Full Colour incompatibility popup
    this.setupFullColourIncompatibilityPopup();
  }

  setupFullColourIncompatibilityPopup() {
    const fullColourBtn = document.getElementById('full-colour-print-btn');
    
    if (fullColourBtn) {
      // Show popup on hover when disabled
      fullColourBtn.addEventListener('mouseenter', () => {
        if (fullColourBtn.classList.contains('disabled')) {
          this.showFullColourIncompatibilityPopup();
        }
      });

      // Hide popup when mouse leaves
      fullColourBtn.addEventListener('mouseleave', () => {
        this.hideFullColourIncompatibilityPopup();
      });
    }
  }

  showFullColourIncompatibilityPopup() {
    // Remove any existing popup
    this.hideFullColourIncompatibilityPopup();
    
    // Get the button
    const fullColourBtn = document.getElementById('full-colour-print-btn');
    if (!fullColourBtn) return;
    
    // Get button position relative to viewport
    const rect = fullColourBtn.getBoundingClientRect();
    
    // Create new popup element
    const popup = document.createElement('div');
    popup.id = 'full-colour-incompatible-popup-new';
    popup.innerHTML = 'Full Colour Print is not available for napkins';
    popup.style.cssText = `
      position: fixed !important;
      top: ${rect.top - 50}px !important;
      left: ${rect.left + rect.width / 2}px !important;
      transform: translateX(-50%) !important;
      background: #dc2626 !important;
      color: white !important;
      padding: 0.75rem 1rem !important;
      border-radius: 8px !important;
      font-size: 0.85rem !important;
      font-weight: 500 !important;
      white-space: nowrap !important;
      opacity: 1 !important;
      visibility: visible !important;
      z-index: 999999 !important;
      box-shadow: 0 8px 16px rgba(220, 38, 38, 0.3) !important;
      pointer-events: none !important;
    `;
    
    // Append to body to avoid opacity inheritance
    document.body.appendChild(popup);
    
    // Auto-hide after 3 seconds
    setTimeout(() => {
      this.hideFullColourIncompatibilityPopup();
    }, 3000);
  }
  
  hideFullColourIncompatibilityPopup() {
    const existingPopup = document.getElementById('full-colour-incompatible-popup-new');
    if (existingPopup) {
      existingPopup.remove();
    }
  }
  
  setupTurnaroundSelector() {
    const turnaroundPills = document.querySelectorAll('.turnaround-pill');
    turnaroundPills.forEach(pill => {
      pill.addEventListener('click', () => {
        // Update selection
        turnaroundPills.forEach(p => p.classList.remove('selected'));
        pill.classList.add('selected');
        
        this.isRushed = pill.dataset.turnaround === 'rushed';
        console.log('Turnaround selected:', pill.dataset.turnaround, 'isRushed:', this.isRushed);
        
      this.updatePricingTable();
        this.updateShippingCalculator();
      });
    });
  }

  setupShippingCalculator() {
    // Initialize the shipping calculator on page load
    this.updateShippingCalculator();
  }

  updateShippingCalculator() {
    const currentDate = new Date();
    const deliveryRangeEl = document.getElementById('delivery-range');
    const orderDateEl = document.getElementById('order-date');
    const shippedDateEl = document.getElementById('shipped-date');
    const doorstepDateEl = document.getElementById('doorstep-date');

    if (!deliveryRangeEl || !orderDateEl || !shippedDateEl || !doorstepDateEl) {
      console.log('Shipping calculator elements not found');
      return;
    }

    // Determine production days and shipping times based on turnaround selection
    const productionDays = this.isRushed ? 5 : 10;
    const minDeliveryDays = this.isRushed ? 6 : 11;
    const maxDeliveryDays = this.isRushed ? 8 : 13;

    // Calculate dates
    const orderDate = new Date(currentDate);
    const shippedDate = this.addBusinessDays(orderDate, productionDays);
    const doorstepDate = this.addBusinessDays(orderDate, maxDeliveryDays);
    const minDoorstepDate = this.addBusinessDays(orderDate, minDeliveryDays);

    // Format dates
    const formatDate = (date) => {
      const options = { month: 'short', day: 'numeric' };
      const suffix = this.getDateSuffix(date.getDate());
      return date.toLocaleDateString('en-US', options).replace(/\d+/, date.getDate() + suffix);
    };

    // Update delivery range with selected production time
    const productionTimeText = this.isRushed ? 'Rushed (5 business days)' : 'Standard (10 business days)';
    
    if (minDeliveryDays === maxDeliveryDays) {
      deliveryRangeEl.textContent = `${productionTimeText} ${formatDate(doorstepDate)}`;
    } else {
      deliveryRangeEl.textContent = `${productionTimeText} ${formatDate(minDoorstepDate)} to ${formatDate(doorstepDate)}`;
    }

    // Update timeline dates
    orderDateEl.textContent = formatDate(orderDate);
    shippedDateEl.textContent = formatDate(shippedDate);
    doorstepDateEl.textContent = formatDate(doorstepDate);
  }

  addBusinessDays(startDate, days) {
    const result = new Date(startDate);
    let addedDays = 0;

    while (addedDays < days) {
      result.setDate(result.getDate() + 1);
      // Skip weekends (Saturday = 6, Sunday = 0)
      if (result.getDay() !== 0 && result.getDay() !== 6) {
        addedDays++;
      }
    }

    return result;
  }

  getDateSuffix(day) {
    if (day >= 11 && day <= 13) {
      return 'th';
    }
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  }

  setupDynamicDescription() {
    // Set up accordion behavior for both desktop and mobile versions
    this.setupAccordionBehavior('.dynamic-description'); // Desktop version
    this.setupAccordionBehavior('.dynamic-description-mobile'); // Mobile version
    
    // Update content initially
    this.updateDynamicDescription();
  }

  openDescriptionTab() {
    // Find the description tab button and content
    const descriptionTab = document.querySelector('[data-tab="description"]');
    const descriptionContent = document.querySelector('[data-tab-content="description"]');
    
    if (descriptionTab && descriptionContent) {
      // Remove active class from all tabs and contents
      document.querySelectorAll('[data-tab]').forEach(tab => tab.classList.remove('active'));
      document.querySelectorAll('[data-tab-content]').forEach(content => content.classList.remove('active'));
      
      // Add active class to description tab and content
      descriptionTab.classList.add('active');
      descriptionContent.classList.add('active');
    }
  }

  setupAccordionBehavior(containerSelector) {
    const container = document.querySelector(containerSelector);
    if (!container) return;
    
    const dropdownTitles = container.querySelectorAll('.dropdown-title');
    
    dropdownTitles.forEach((title, index) => {
      // Force bold styling directly on the element
      title.style.fontWeight = '700';
      title.style.setProperty('font-weight', '700', 'important');
      
      // Remove any existing listeners to prevent duplicates
      const newTitle = title.cloneNode(true);
      title.parentNode.replaceChild(newTitle, title);
      
      newTitle.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        const targetId = newTitle.getAttribute('data-target');
        const content = document.getElementById(targetId);
        const arrow = newTitle.querySelector('.dropdown-arrow');
        
        if (content) {
          const isCurrentlyActive = newTitle.classList.contains('active');
          
          // Close all dropdowns in this container first
          container.querySelectorAll('.dropdown-title').forEach(otherTitle => {
            const otherTargetId = otherTitle.getAttribute('data-target');
            const otherContent = document.getElementById(otherTargetId);
            const otherArrow = otherTitle.querySelector('.dropdown-arrow');
            
            if (otherContent) {
              otherTitle.classList.remove('active');
              otherContent.classList.remove('active');
              if (otherArrow) {
                otherArrow.style.transform = 'rotate(0deg)';
              }
            }
          });
          
          // If this wasn't active, open it
          if (!isCurrentlyActive) {
            newTitle.classList.add('active');
            content.classList.add('active');
            if (arrow) {
              arrow.style.transform = 'rotate(180deg)';
            }
          }
        }
      });
      
      // Set initial state - Description opens by default, plus rows marked active in markup.
      const targetId = newTitle.getAttribute('data-target');
      const content = document.getElementById(targetId);
      const arrow = newTitle.querySelector('.dropdown-arrow');
      
      if (content) {
        const shouldOpen = index === 0 || newTitle.classList.contains('active') || content.classList.contains('active');

        if (shouldOpen) {
          newTitle.classList.add('active');
          content.classList.add('active');
          if (arrow) {
            arrow.style.transform = 'rotate(180deg)';
          }
        } else {
          newTitle.classList.remove('active');
          content.classList.remove('active');
          if (arrow) {
            arrow.style.transform = 'rotate(0deg)';
          }
        }
      }
    });
  }

  updateDynamicDescription() {
    const descriptionData = this.getDescriptionData();
    
    // Update desktop version
    const descriptionContent = document.getElementById('description-content');
    const specificationContent = document.getElementById('specification-content');
    const dielinesContent = document.getElementById('dielines-content');
    const howItWorksContent = document.getElementById('how-it-works-content');
    
    // Update mobile version
    const descriptionContentMobile = document.getElementById('description-content-mobile');
    const specificationContentMobile = document.getElementById('specification-content-mobile');
    const dielinesContentMobile = document.getElementById('dielines-content-mobile');
    const howItWorksContentMobile = document.getElementById('how-it-works-content-mobile');
    
    if (descriptionData) {
      // Update desktop
      if (descriptionContent) {
        descriptionContent.innerHTML = descriptionData.description;
      }
      if (specificationContent) {
        specificationContent.innerHTML = descriptionData.specification;
      }
      if (dielinesContent) {
        dielinesContent.innerHTML = descriptionData.dielines;
      }
      if (howItWorksContent && !howItWorksContent.hasAttribute('data-static-journey')) {
        howItWorksContent.innerHTML = descriptionData.howItWorks;
      }
      
      // Update mobile (same content)
      if (descriptionContentMobile) {
        descriptionContentMobile.innerHTML = descriptionData.description;
      }
      if (specificationContentMobile) {
        specificationContentMobile.innerHTML = descriptionData.specification;
      }
      if (dielinesContentMobile) {
        dielinesContentMobile.innerHTML = descriptionData.dielines;
      }
      if (howItWorksContentMobile && !howItWorksContentMobile.hasAttribute('data-static-journey')) {
        howItWorksContentMobile.innerHTML = descriptionData.howItWorks;
      }
    }
  }

  getDescriptionData() {
    const napkinDescriptions = {
      "Cocktail 25x25cm": {
        description: `
          <p>Our Cocktail Napkins (12cm x 12cm) are perfect for bars, restaurants, events, and premium hospitality venues. Made from premium quality absorbent material, these compact napkins provide excellent functionality while showcasing your brand with professional-quality printing.</p>
          <p><strong>Available with Simple Print only:</strong></p>
          <p>• <strong>Simple Print:</strong> Clean, professional logo or design prints on premium napkin material<br>
          • Perfect for branding, event promotion, and hospitality use</p>
          <p><strong>Minimum order: 250 units.</strong></p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Size:</span> <span class="spec-value">12cm x 12cm (Cocktail size)</span></li>
            <li><span class="spec-label">Material:</span> <span class="spec-value">Premium absorbent napkin material</span></li>
            <li><span class="spec-label">Ply:</span> <span class="spec-value">2-ply for enhanced absorbency</span></li>
            <li><span class="spec-label">Print Type:</span> <span class="spec-value">Simple Print only</span></li>
            <li><span class="spec-label">MOQ:</span> <span class="spec-value">250 units</span></li>
            <li><span class="spec-label">Production Time:</span> <span class="spec-value">Standard (10 business days)</span></li>
            <li><span class="spec-label">Packaging:</span> <span class="spec-value">Bulk packed in protective cartons</span></li>
            <li><span class="spec-label">Use:</span> <span class="spec-value">Ideal for bars, events, and cocktail service</span></li>
          </ul>
        `,
        dielines: `
          <p>To ensure perfect print placement, download the dieline below and apply your design:</p>
          <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/Cocktail_12x12_cm_Template.pdf?v=1756095981" class="download-btn" target="_blank" rel="noopener">📄 Download Cocktail Napkin Template (PDF)</a>
          <p style="margin-top: 1rem; font-size: 0.9rem; color: #64748b;">Need help with templates or setting up your artwork? Get in touch — we're here to make it easy.</p>
        `,
        howItWorks: `
          <div class="process-timeline">
            <div class="process-step">
              <div class="process-number">1</div>
              <div class="process-text"><strong>Choose Your Options</strong><br>Select napkin size, quantity, and upload your artwork files.</div>
            </div>
            <div class="process-step">
              <div class="process-number">2</div>
              <div class="process-text"><strong>Approve Your Artwork</strong><br>We'll send you a digital mockup for review. Nothing goes to print without your sign-off.</div>
            </div>
            <div class="process-step">
              <div class="process-number">3</div>
              <div class="process-text"><strong>Production Begins</strong><br>Once approved, your custom napkins go into production — standard turnaround is 10 business days.</div>
            </div>
            <div class="process-step">
              <div class="process-number">4</div>
              <div class="process-text"><strong>Dispatched & Delivered</strong><br>Your order is packed, shipped via tracked courier, and on its way. We'll email you tracking info once it's out the door.</div>
            </div>
          </div>
        `
      },
      "2-Ply Folded Napkin 10x20cm": {
        description: `
          <p>Our 2-Ply Folded Napkins (10cm x 20cm when folded) are perfect for restaurants, cafes, takeaway services, and catering events. High-quality, durable, and fully customizable, these napkins provide excellent absorbency while delivering professional brand presentation.</p>
          <p><strong>Available with Simple Print only:</strong></p>
          <p>• <strong>Simple Print:</strong> Professional logo or design prints on premium folded napkin material<br>
          • Perfect for restaurant branding, event promotion, and food service</p>
          <p><strong>Minimum order: 250 units.</strong></p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Size:</span> <span class="spec-value">10cm x 20cm (folded)</span></li>
            <li><span class="spec-label">Material:</span> <span class="spec-value">Premium absorbent napkin material</span></li>
            <li><span class="spec-label">Ply:</span> <span class="spec-value">2-ply for superior absorbency</span></li>
            <li><span class="spec-label">Print Type:</span> <span class="spec-value">Simple Print only</span></li>
            <li><span class="spec-label">MOQ:</span> <span class="spec-value">250 units</span></li>
            <li><span class="spec-label">Production Time:</span> <span class="spec-value">Standard (10 business days)</span></li>
            <li><span class="spec-label">Packaging:</span> <span class="spec-value">Bulk packed in protective cartons</span></li>
            <li><span class="spec-label">Use:</span> <span class="spec-value">Perfect for restaurants, cafes, and food service</span></li>
          </ul>
        `,
        dielines: `
          <p>To ensure perfect print placement, download the dieline below and apply your design:</p>
          <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/2-Ply_Folded_Dinner_10x20_cm_Template.pdf?v=1756095981" class="download-btn" target="_blank" rel="noopener">📄 Download 2-Ply Folded Napkin Template (PDF)</a>
          <p style="margin-top: 1rem; font-size: 0.9rem; color: #64748b;">Need help with templates or setting up your artwork? Get in touch — we're here to make it easy.</p>
        `,
        howItWorks: `
          <div class="process-timeline">
            <div class="process-step">
              <div class="process-number">1</div>
              <div class="process-text"><strong>Choose Your Options</strong><br>Select napkin size, quantity, and upload your artwork files.</div>
            </div>
            <div class="process-step">
              <div class="process-number">2</div>
              <div class="process-text"><strong>Approve Your Artwork</strong><br>We'll send you a digital mockup for review. Nothing goes to print without your sign-off.</div>
            </div>
            <div class="process-step">
              <div class="process-number">3</div>
              <div class="process-text"><strong>Production Begins</strong><br>Once approved, your custom napkins go into production — standard turnaround is 10 business days.</div>
             </div>
             <div class="process-step">
               <div class="process-number">4</div>
               <div class="process-text"><strong>Dispatched & Delivered</strong><br>Your order is packed, shipped via tracked courier, and on its way. We'll email you tracking info once it's out the door.</div>
             </div>
           </div>
         `
       }
    };
    
    return napkinDescriptions[this.selectedSize] || napkinDescriptions["Cocktail 25x25cm"];
  }

  setupTooltips() {
    const tooltipIcons = document.querySelectorAll('.tooltip-icon[data-tooltip]');
    
    tooltipIcons.forEach(icon => {
      let tooltip = null;
      
      const showTooltip = (e) => {
        // Remove any existing tooltips
        document.querySelectorAll('.tooltip-popup').forEach(t => t.remove());
        
        const tooltipText = icon.getAttribute('data-tooltip');
        if (!tooltipText) return;
        
        // Create tooltip element
        tooltip = document.createElement('div');
        tooltip.className = 'tooltip-popup';
        tooltip.innerHTML = tooltipText;
        
        // Style the tooltip
        Object.assign(tooltip.style, {
          position: 'absolute',
          background: '#000000',
          color: '#ffffff',
          padding: '12px 16px',
          borderRadius: '6px',
          fontSize: '14px',
          fontWeight: '400',
          lineHeight: '1.4',
          maxWidth: '300px',
          width: 'auto',
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
          zIndex: '9999',
          opacity: '0',
          visibility: 'hidden',
          transition: 'all 0.2s ease',
          pointerEvents: 'none'
        });
        
        // Add to DOM - append to the icon's parent container for better positioning
        const container = icon.closest('.form__label') || icon.parentElement;
        container.style.position = 'relative';
        container.appendChild(tooltip);
        
        // Position tooltip relative to icon
        const iconRect = icon.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();
        
        // Get tooltip dimensions after adding to DOM
        tooltip.style.visibility = 'visible';
        tooltip.style.opacity = '0';
        const tooltipRect = tooltip.getBoundingClientRect();
        tooltip.style.visibility = 'hidden';
        
        // Calculate position relative to container
        const iconLeft = iconRect.left - containerRect.left;
        const iconTop = iconRect.top - containerRect.top;
        
        // Position above the icon, centered horizontally
        let left = iconLeft + (iconRect.width / 2) - (tooltipRect.width / 2);
        let top = iconTop - tooltipRect.height - 8;
        
        // Keep tooltip within viewport
        const viewportWidth = window.innerWidth;
        const tooltipLeftInViewport = containerRect.left + left;
        const tooltipRightInViewport = tooltipLeftInViewport + tooltipRect.width;
        
        // Adjust horizontal position if going off screen
        if (tooltipLeftInViewport < 10) {
          left = 10 - containerRect.left;
        } else if (tooltipRightInViewport > viewportWidth - 10) {
          left = (viewportWidth - 10 - containerRect.left) - tooltipRect.width;
        }
        
        // If no room above, show below
        if (containerRect.top + top < 10) {
          top = iconTop + iconRect.height + 8;
        }
        
        tooltip.style.left = left + 'px';
        tooltip.style.top = top + 'px';
        
        // Show tooltip
        requestAnimationFrame(() => {
          tooltip.style.opacity = '1';
          tooltip.style.visibility = 'visible';
        });
      };
      
      const hideTooltip = () => {
        if (tooltip) {
          tooltip.style.opacity = '0';
          tooltip.style.visibility = 'hidden';
          setTimeout(() => {
            if (tooltip && tooltip.parentNode) {
              tooltip.parentNode.removeChild(tooltip);
            }
            tooltip = null;
          }, 200);
        }
      };
      
      // Add event listeners
      icon.addEventListener('mouseenter', showTooltip);
      icon.addEventListener('mouseleave', hideTooltip);
      icon.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
      });
    });
    
    // Clean up tooltips on page interactions
    document.addEventListener('scroll', () => {
      document.querySelectorAll('.tooltip-popup').forEach(t => {
        if (t.parentNode) t.parentNode.removeChild(t);
      });
    });
    
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.tooltip-icon')) {
        document.querySelectorAll('.tooltip-popup').forEach(t => {
          if (t.parentNode) t.parentNode.removeChild(t);
        });
      }
    });
  }
  
  setupFormSubmission() {
    const customButton = document.getElementById('custom-add-to-cart-btn');
    if (customButton) {
      customButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.addToCart();
      });
    }
  }
  
  setupFileUpload() {
    const fileInput = document.querySelector('input[type="file"][name="properties[Design File]"]');
    if (!fileInput) {
      console.log('File upload input not found');
      return;
    }

    const uploadArea = document.querySelector('div[id^="uploadArea-"]');
    const imagePreview = document.querySelector('img[id^="imagePreview-"]');
    const filePreviewArea = document.querySelector('div[id^="filePreviewArea-"]');
    const fileInfo = document.querySelector('div[id^="fileInfo-"]');
    const fileName = document.querySelector('div[id^="fileName-"]');
    const fileSize = document.querySelector('div[id^="fileSize-"]');
    const removeButton = document.querySelector('button[id^="removeFile-"]');

    // Click handler for upload area
    if (uploadArea) {
      uploadArea.addEventListener('click', () => {
        fileInput.click();
      });

      // Drag and drop handlers
      uploadArea.addEventListener('dragover', (e) => {
        e.preventDefault();
        uploadArea.style.borderColor = '#3b82f6';
        uploadArea.style.backgroundColor = '#eff6ff';
      });

      uploadArea.addEventListener('dragleave', (e) => {
        e.preventDefault();
        uploadArea.style.borderColor = '#cbd5e1';
        uploadArea.style.backgroundColor = '#f8fafc';
      });

      uploadArea.addEventListener('drop', (e) => {
        e.preventDefault();
        uploadArea.style.borderColor = '#cbd5e1';
        uploadArea.style.backgroundColor = '#f8fafc';
        
        const files = e.dataTransfer.files;
        if (files.length) {
          fileInput.files = files;
          this.handleFileSelection(files[0]);
        }
      });
    }

    // File selection handler
    fileInput.addEventListener('change', (e) => {
      const file = e.target.files[0];
      this.handleFileSelection(file);
    });

    // Remove file handler
    if (removeButton) {
      removeButton.addEventListener('click', (e) => {
        e.stopPropagation();
        this.clearFileSelection();
      });
    }
  }

  handleFileSelection(file) {
    const uploadArea = document.querySelector('div[id^="uploadArea-"]');
    const imagePreview = document.querySelector('img[id^="imagePreview-"]');
    const filePreviewArea = document.querySelector('div[id^="filePreviewArea-"]');
    const fileName = document.querySelector('div[id^="fileName-"]');
    const fileSize = document.querySelector('div[id^="fileSize-"]');

    if (!file) {
      this.clearFileSelection();
      return;
    }

    // Validate file size (max 10MB)
    if (file.size > 10 * 1024 * 1024) {
      alert('File size must be less than 10MB');
      this.clearFileSelection();
      return;
    }

    // Hide upload area and show preview
    if (uploadArea) uploadArea.style.display = 'none';
    if (filePreviewArea) filePreviewArea.style.display = 'block';

    // Update file info
    if (fileName) fileName.textContent = file.name;
    if (fileSize) fileSize.textContent = `${(file.size / 1024 / 1024).toFixed(2)}MB`;

    // Show image preview for image files
    if (file.type.startsWith('image/') && imagePreview) {
      const reader = new FileReader();
      reader.onload = (e) => {
        imagePreview.src = e.target.result;
        imagePreview.style.display = 'block';
      };
      reader.readAsDataURL(file);
    } else {
      // Hide image preview for non-image files
      if (imagePreview) imagePreview.style.display = 'none';
    }

    console.log('File selected:', file.name, file.type, file.size);
  }

  clearFileSelection() {
    const fileInput = document.querySelector('input[type="file"][name="properties[Design File]"]');
    const uploadArea = document.querySelector('div[id^="uploadArea-"]');
    const imagePreview = document.querySelector('img[id^="imagePreview-"]');
    const filePreviewArea = document.querySelector('div[id^="filePreviewArea-"]');

    // Clear the file input
    if (fileInput) fileInput.value = '';

    // Show upload area and hide preview
    if (uploadArea) uploadArea.style.display = 'block';
    if (filePreviewArea) filePreviewArea.style.display = 'none';
    if (imagePreview) imagePreview.style.display = 'none';

    console.log('File selection cleared');
  }
  
  updatePrintTypeAvailability() {
    const fullColourBtn = document.getElementById('full-colour-print-btn');
    const unavailableIndicator = fullColourBtn?.querySelector('.unavailable-indicator');
    
    if (fullColourBtn && unavailableIndicator) {
      // Full Colour Print is never available for napkins
        fullColourBtn.classList.add('disabled');
        unavailableIndicator.style.display = 'inline';
        
        // Switch to Simple Print if Full Colour was selected
        if (this.selectedPrintType === 'FullColour') {
          const simplePrintBtn = document.getElementById('simple-print-btn');
          if (simplePrintBtn) {
            simplePrintBtn.click();
        }
      }
    }
  }
  
  getPricingKey() {
    const printType = this.selectedPrintType === 'FullColour' ? 'FullColour' : 'Simple';
    return `${this.selectedSize}_${printType}`;
  }

  async loadProductData() {
    if (this.productData) return this.productData;
    
    try {
      // First try to get from existing ProductJSON script
      const productScript = document.querySelector(`script[id^="ProductJSON-"]`);
      if (productScript) {
        this.productData = JSON.parse(productScript.textContent);
        console.log('Loaded product data from script:', this.productData.handle);
        return this.productData;
      }
      
      // Fallback: fetch from API using product handle from URL
      const pathParts = window.location.pathname.split('/');
      const handle = pathParts[pathParts.indexOf('products') + 1];
      
      if (handle) {
        const response = await fetch(`/products/${handle}.js`);
        this.productData = await response.json();
        console.log('Loaded product data from API:', this.productData.handle);
        return this.productData;
      }
      
      throw new Error('Could not determine product handle');
    } catch (error) {
      console.error('Failed to load product data:', error);
      return null;
    }
  }



  async updatePricingTable() {
      const tbody = document.getElementById('quantity-grid-body');
      if (!tbody) return;

    const pricingKey = this.getPricingKey();
    const variants = this.variantMapping[pricingKey];
    
    console.log('Updating pricing for:', pricingKey, variants);
    
    if (!variants) {
      tbody.innerHTML = '<tr><td colspan="5" style="text-align: center; padding: 2em;">No pricing available for this configuration</td></tr>';
      return;
    }
    
    // Load product data for price lookup
    await this.loadProductData();
    
      tbody.innerHTML = '';

    // Get available quantities for this configuration
    const quantities = Object.keys(variants).map(q => parseInt(q)).sort((a, b) => a - b);
    
    for (let i = 0; i < quantities.length; i++) {
      const qty = quantities[i];
      const variantId = variants[qty.toString()];
      
      // Try to find variant in product data
      let variant = null;
      let variantPrice = 0;
      let unitPrice = 0;
      
      if (this.productData) {
        variant = this.productData.variants.find(v => v.id == variantId);
      }
      
      console.log(`[Pricing Debug] ${pricingKey} - Qty: ${qty}, VariantID: ${variantId}, Found: ${!!variant}`);
      
      if (variant) {
        // Use live Shopify pricing
        if (typeof variant.price === 'string') {
          variantPrice = parseFloat(variant.price);
        } else {
          // Assume cents, convert to dollars
          variantPrice = variant.price / 100;
        }
        unitPrice = variantPrice / qty;
      } else {
        // Fallback: calculate estimated pricing based on quantity tiers
        console.warn(`Using fallback pricing for ${pricingKey} ${qty} units (variant ${variantId} not found)`);
        
        // Basic tiered pricing fallback for napkins
        if (qty >= 5000) unitPrice = 0.25;
        else if (qty >= 4000) unitPrice = 0.28;
        else if (qty >= 3000) unitPrice = 0.30;
        else if (qty >= 2000) unitPrice = 0.35;
        else if (qty >= 1000) unitPrice = 0.45;
        else if (qty >= 500) unitPrice = 0.65;
        else unitPrice = 0.80;
        
        // Adjust for napkin type
        if (pricingKey.includes('2-Ply Folded')) {
          unitPrice *= 1.1; // Folded napkins cost slightly more
        }
        
        variantPrice = unitPrice * qty;
      }
      
      const row = document.createElement('tr');
      row.classList.add('quantity-row');
      row.dataset.quantity = qty;
      
      // Make entire row clickable
      row.addEventListener('click', () => {
        const radio = row.querySelector('input[type="radio"]');
        if (radio) {
          radio.checked = true;
          this.selectedQuantity = qty;
          this.currentUnitPrice = unitPrice;
          this.updateRowSelection();
          this.updateSelectedQuantityDisplay();
          this.updateMediaGalleryForSelectedVariant();
        }
      });
      
      // Radio button
      const radioCell = document.createElement('td');
      const radio = document.createElement('input');
      radio.type = 'radio';
      radio.name = 'quantity_selection';
      radio.value = qty;
      radio.addEventListener('change', () => {
        if (radio.checked) {
          this.selectedQuantity = qty;
          this.currentUnitPrice = unitPrice;
          this.updateRowSelection();
          this.updateSelectedQuantityDisplay();
          this.updateMediaGalleryForSelectedVariant();
        }
      });
      
      // Pre-select first option or maintain current selection
      if ((i === 0 && this.selectedQuantity === null) || qty === this.selectedQuantity) {
        radio.checked = true;
        this.selectedQuantity = qty;
        this.currentUnitPrice = unitPrice;
        row.classList.add('selected');
      }
      
      radioCell.appendChild(radio);
      row.appendChild(radioCell);
        
      // Quantity
      const qtyCell = document.createElement('td');
      qtyCell.textContent = qty.toLocaleString();
      row.appendChild(qtyCell);

      // Unit Price with membership pricing
      const unitPriceCell = document.createElement('td');
      
      // Check for membership pricing
      const customerTags = document.body.dataset.customerTags || '';
      const tags = customerTags.toLowerCase().split(',').map(tag => tag.trim());
      let memberTier = null;
      let discountPercent = 0;
      
      if (window.MembershipPricing) {
        memberTier = window.MembershipPricing.getCustomerTier();
        discountPercent = window.MembershipPricing.getDiscountPercent();
      } else {
        // Fallback to legacy logic for bronze/silver/gold/trade
        if (tags.includes('trade')) {
          memberTier = 'trade';
          discountPercent = 20;
        } else if (tags.includes('gold')) {
          memberTier = 'gold';
          discountPercent = 15;
        } else if (tags.includes('silver')) {
          memberTier = 'silver';
          discountPercent = 10;
        } else if (tags.includes('bronze')) {
          memberTier = 'bronze';
          discountPercent = 5;
        }
      }
      
      if (memberTier && discountPercent > 0) {
        const discountedUnitPrice = unitPrice * (1 - discountPercent / 100);
        console.log(`[Membership Debug] Unit Price - Original: $${unitPrice.toFixed(2)}, Discounted: $${discountedUnitPrice.toFixed(2)}, Tier: ${memberTier}`);
        
        unitPriceCell.innerHTML = `
          <span class="original-price">$${unitPrice.toFixed(2)}</span>
          <span class="member-price member-${memberTier}">$${discountedUnitPrice.toFixed(2)}</span>
          <span class="membership-badge membership-${memberTier}">${memberTier === 'trade' ? '💎' : memberTier === 'gold' ? '🥇' : memberTier === 'silver' ? '🥈' : '🥉'}</span>
        `;
      } else {
        unitPriceCell.textContent = `$${unitPrice.toFixed(2)}`;
      }
      unitPriceCell.style.textAlign = 'center';
      row.appendChild(unitPriceCell);

      // Total Price with membership discount
      const totalCell = document.createElement('td');
      
      if (memberTier && discountPercent > 0) {
        const discountedTotal = variantPrice * (1 - discountPercent / 100);
        totalCell.innerHTML = `
          <span class="original-price">$${variantPrice.toFixed(2)}</span>
          <span class="member-price member-${memberTier}">$${discountedTotal.toFixed(2)}</span>
        `;
      } else {
        totalCell.textContent = `$${variantPrice.toFixed(2)}`;
      }
      row.appendChild(totalCell);

        tbody.appendChild(row);
    }

    this.updateRowSelection();
    this.updateSelectedQuantityDisplay();
    this.updateOrderSummary();
    }

  updateRowSelection() {
    // Remove selection from all rows
    document.querySelectorAll('.quantity-row').forEach(row => {
      row.classList.remove('selected');
    });
    
    // Add selection to current row
    if (this.selectedQuantity) {
      const selectedRow = document.querySelector(`[data-quantity="${this.selectedQuantity}"]`);
      if (selectedRow) {
        selectedRow.classList.add('selected');
      }
    }
  }
  
  updateSelectedQuantityDisplay() {
    // Update any selected quantity display elements
    const selectedQtyElements = document.querySelectorAll('.selected-quantity-display');
    selectedQtyElements.forEach(el => {
      el.textContent = this.selectedQuantity ? this.selectedQuantity.toLocaleString() : '';
    });
    
    // Update order summary
    this.updateOrderSummary();
  }
  
  updateOrderSummary() {
    if (!this.selectedQuantity) return;
    
    // Get current pricing for display calculations
    const pricingKey = this.getPricingKey();
    const variants = this.variantMapping[pricingKey];
    const variant = variants[this.selectedQuantity.toString()];
    
    if (!variant) {
      console.warn(`Variant not found for quantity: ${this.selectedQuantity}`);
      return;
    }
    
    // Get membership info for all calculations
    const customerTags = document.body.dataset.customerTags || '';
    const tags = customerTags.toLowerCase().split(',').map(tag => tag.trim());
    // Use centralized membership pricing system
    let memberTier = null;
    let memberDiscountPercent = 0;
    
    if (window.MembershipPricing) {
      memberTier = window.MembershipPricing.getCustomerTier();
      memberDiscountPercent = window.MembershipPricing.getDiscountPercent();
    } else {
      // Fallback to legacy logic for bronze/silver/gold/trade
      if (tags.includes('trade')) {
        memberTier = 'trade';
        memberDiscountPercent = 20;
      } else if (tags.includes('gold')) {
        memberTier = 'gold';
        memberDiscountPercent = 15;
      } else if (tags.includes('silver')) {
        memberTier = 'silver';
        memberDiscountPercent = 10;
      } else if (tags.includes('bronze')) {
        memberTier = 'bronze';
        memberDiscountPercent = 5;
      }
    }
    
    let unitPrice = this.calculateUnitPrice();
    let rushFee = 0;
    // Calculate napkin total and apply member discount
    let napkinTotal = this.selectedQuantity * unitPrice;
    
    // Apply member discount to napkin total
    if (memberDiscountPercent > 0) {
      napkinTotal = napkinTotal * (1 - memberDiscountPercent / 100);
      console.log(`[Napkin Debug] Member discount applied to napkin total: ${memberDiscountPercent}% off`);
    }
    
    let totalPrice = napkinTotal;

    // No lids for napkins - hide lid row
    const lidRow = document.getElementById('summary-lid-row');
    if (lidRow) {
      lidRow.style.display = 'none';
    }

    // Add rush surcharge (for display purposes) - Rush fee should be calculated on discounted price
    if (this.isRushed) {
      // Calculate rush fee based on the discounted napkin total for members
      let baseNapkinTotal = this.selectedQuantity * unitPrice;
      
      // Apply member discount to the base total before calculating rush fee
      if (memberDiscountPercent > 0) {
        baseNapkinTotal = baseNapkinTotal * (1 - memberDiscountPercent / 100);
        console.log(`[Rush Debug] Member discount applied to rush calculation: ${memberDiscountPercent}% off`);
        // Don't round rush fee for members since discount is applied at product level
        rushFee = baseNapkinTotal * (this.RUSH_MULTIPLIER - 1);
      } else {
        // Keep rounding for non-members
        rushFee = Math.round(baseNapkinTotal * (this.RUSH_MULTIPLIER - 1));
      }
      totalPrice += rushFee;
      
      console.log(`[Rush Debug] Rush fee calculated: Base: $${baseNapkinTotal.toFixed(2)} -> Rush: $${rushFee.toFixed(2)}`);
      
      document.getElementById('summary-rush-row').style.display = '';
      
      // Display rush fee with original/discounted format for members
      if (memberDiscountPercent > 0) {
        const originalNapkinTotal = this.selectedQuantity * unitPrice;
        const originalRushFee = Math.round(originalNapkinTotal * (this.RUSH_MULTIPLIER - 1));
        document.getElementById('summary-rush-fee').innerHTML = `
          <span class="original-price">$${originalRushFee.toFixed(2)}</span>
          <span class="member-price member-${memberTier}">$${rushFee.toFixed(2)}</span>
        `;
      } else {
        document.getElementById('summary-rush-fee').textContent = `$${rushFee.toFixed(2)}`;
      }
    } else {
      document.getElementById('summary-rush-row').style.display = 'none';
      document.getElementById('summary-rush-fee').textContent = '$0.00';
      }

    // Update summary elements (with membership pricing)
    const summaryQuantity = document.getElementById('summary-quantity');
    const summaryUnitPrice = document.getElementById('summary-unit-price');
    const summaryTotal = document.getElementById('summary-total');
    
    if (summaryQuantity) summaryQuantity.textContent = this.selectedQuantity.toLocaleString();
    
    if (summaryUnitPrice) {
      if (memberTier && memberDiscountPercent > 0) {
        const discountedUnitPrice = unitPrice * (1 - memberDiscountPercent / 100);
        console.log(`[Membership Debug] Summary Unit Price - Original: $${unitPrice.toFixed(2)}, Discounted: $${discountedUnitPrice.toFixed(2)}, Tier: ${memberTier}`);
        summaryUnitPrice.innerHTML = `
          <span class="original-price">$${unitPrice.toFixed(2)}</span>
          <span class="member-price member-${memberTier}">$${discountedUnitPrice.toFixed(2)}</span>
        `;
      } else {
        summaryUnitPrice.textContent = `$${unitPrice.toFixed(2)}`;
      }
    }
    
    if (summaryTotal) {
      if (memberTier && memberDiscountPercent > 0) {
        // For members: Calculate original totals to show accurate total savings
        const originalNapkinTotal = this.selectedQuantity * unitPrice;
        const originalRushFee = this.isRushed ? Math.round(originalNapkinTotal * (this.RUSH_MULTIPLIER - 1)) : 0;
        const originalSubtotal = originalNapkinTotal + originalRushFee;
        
        // Calculate individual savings breakdown for accurate total
        const napkinSavings = originalNapkinTotal * (memberDiscountPercent / 100);
        const rushFeeSavings = originalRushFee - rushFee; // Difference between original and discounted rush fee
        const totalSavings = napkinSavings + rushFeeSavings;
        
        console.log(`[Membership Debug] Savings Breakdown:`);
        console.log(`- Napkin Savings (${memberDiscountPercent}%): $${napkinSavings.toFixed(2)}`);
        console.log(`- Rush Fee Savings: $${rushFeeSavings.toFixed(2)}`);
        console.log(`- Total Member Savings: $${totalSavings.toFixed(2)}`);
        console.log(`- Original Subtotal: $${originalSubtotal.toFixed(2)}`);
        console.log(`- Final Total: $${totalPrice.toFixed(2)}`);
        console.log(`- Verification: ${originalSubtotal.toFixed(2)} - ${totalSavings.toFixed(2)} = ${(originalSubtotal - totalSavings).toFixed(2)}`);
        
        // Display final total with original subtotal crossed out
        summaryTotal.innerHTML = `
          <span class="original-price">$${originalSubtotal.toFixed(2)}</span>
          <span class="member-price member-${memberTier}">$${totalPrice.toFixed(2)}</span>
        `;
        
        // Show and update discount row ONLY for tagged members
        const discountRow = document.getElementById('summary-discount-row');
        const discountLabel = document.getElementById('summary-discount-label');
        const discountAmountEl = document.getElementById('summary-discount-amount');
        
        if (discountRow && discountLabel && discountAmountEl) {
          console.log(`[Discount Debug] Showing accurate total savings for ${memberTier} member: -$${totalSavings.toFixed(2)}`);
          discountRow.style.display = 'flex'; // Show the discount row
          discountLabel.textContent = `${memberTier.toUpperCase()} Member Discount (${memberDiscountPercent}%):`;
          discountAmountEl.textContent = `-$${totalSavings.toFixed(2)}`;
          discountAmountEl.style.color = '#28a745'; // Green color for savings
          discountAmountEl.style.fontWeight = '600'; // Make it stand out
        }
      } else {
        summaryTotal.textContent = `$${totalPrice.toFixed(2)}`;
        
        // Hide discount row for non-members
        const discountRow = document.getElementById('summary-discount-row');
        if (discountRow) {
          console.log('[Discount Debug] Hiding discount row - no membership tags found');
          discountRow.style.display = 'none';
        }
      }
    }
  }

  async addToCart() {
    const button = document.getElementById('custom-add-to-cart-btn');
    if (!button) return;

    // Validate that a design file is uploaded
    const fileInput = document.querySelector('input[type="file"][name="properties[Design File]"]');
    // File upload is now optional, so skip this check

    // Show loading state
    button.classList.add('loading');
    button.disabled = true;

    try {
      // Get the correct variant ID based on shape, print type, and quantity
      const pricingKey = this.getPricingKey();
      const quantityKey = String(this.selectedQuantity);
      const variantId = this.variantMapping[pricingKey]?.[quantityKey];
      
      console.log('[AddToCart Debug] Selected variant ID:', variantId);
      
      if (!variantId) {
        throw new Error(`No variant found for ${pricingKey} - ${quantityKey} units.`);
      }

      // Create FormData to handle file upload
      const formData = new FormData();

      // Shared group id so the napkin and its rush fee stay linked in the cart
      // (cart grouping keys off _epk_group). Without this the rush fee renders as
      // a separate, unlinked card.
      const epkGroup = 'epkorder-' + Date.now().toString(36) + '-' + Math.floor(Math.random() * 1000000).toString(36);

      // Add the main napkin variant
      formData.append('items[0][id]', variantId);
      formData.append('items[0][quantity]', '1');
      formData.append('items[0][properties][Shape]', this.selectedSize);
      formData.append('items[0][properties][Print Type]', this.selectedPrintType);
      formData.append('items[0][properties][Quantity]', this.selectedQuantity);
      formData.append('items[0][properties][Price/Unit]', `$${this.calculateUnitPrice().toFixed(2)}`);
      formData.append('items[0][properties][_epk_group]', epkGroup);
      
      // Add the uploaded file
      const fileInput = document.querySelector('input[type="file"][name="properties[Design File]"]');
      if (fileInput && fileInput.files[0]) {
        formData.append('items[0][properties][Design File]', fileInput.files[0]);
      }

      let itemIndex = 1; // Start next items at index 1

      // Add rush fee as separate product if rushed is selected
      if (this.isRushed) {
        const variantTotalPrice = this.calculateVariantTotalPrice();
        const rushFeeAmount = variantTotalPrice * (this.RUSH_MULTIPLIER - 1);
        const rushFeeQuantity = Math.round(rushFeeAmount);
        
        formData.append(`items[${itemIndex}][id]`, '50675778126106');
        formData.append(`items[${itemIndex}][quantity]`, rushFeeQuantity);
        formData.append(`items[${itemIndex}][properties][Base Order Total]`, `$${variantTotalPrice.toFixed(2)}`);
        formData.append(`items[${itemIndex}][properties][Rush Fee (5 business days) +30%]`, `$${rushFeeAmount.toFixed(2)}`);
        formData.append(`items[${itemIndex}][properties][_epk_group]`, epkGroup);
      }

      // Submit to cart using FormData (supports file uploads)
      const response = await fetch('/cart/add', {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to add to cart: ${response.status} - ${errorText}`);
      }

      // Success
      document.dispatchEvent(new CustomEvent('cart:updated'));
      // Set flag for success state after page refresh
      localStorage.setItem('cartAddSuccess', 'true');
      // Reload page to update cart UI (since we're using form submission)
      setTimeout(() => {
        window.location.reload();
      }, 1000);

    } catch (error) {
      console.error('Cart error:', error);
      this.showMessage(`Error adding to cart: ${error.message}`, 'error');
    } finally {
      button.classList.remove('loading');
      button.disabled = false;
    }
  }
  
  calculateUnitPrice() {
    // Return the cached unit price from live data
    return this.currentUnitPrice || 0;
  }

  // Helper method to calculate variant total price
  calculateVariantTotalPrice() {
    // Calculate total price dynamically based on current pricing data
    const unitPrice = this.calculateUnitPrice();
    const totalPrice = unitPrice * this.selectedQuantity;
    
    console.log(`[VariantTotalPrice] Unit: $${unitPrice}, Qty: ${this.selectedQuantity}, Total: $${totalPrice}`);
    
    return totalPrice;
  }
  
  showMessage(text, type) {
    console.log('showMessage called:', text, type);
    
    // Remove existing messages
    const existingMessages = document.querySelectorAll('.cup-message');
    existingMessages.forEach(msg => msg.remove());
    
    // Create new toast message
    const message = document.createElement('div');
    message.className = `cup-message cup-${type}-message cup-toast-message`;
    message.textContent = text;
    
    // Position the toast near the Add to cart button
    const addToCartButton = document.querySelector('#custom-add-to-cart-btn') || 
                           document.querySelector('.custom-add-to-cart-button') ||
                           document.querySelector('.product-form-cup__cart-submit') || 
                           document.querySelector('#product-form-cup button[type="submit"]') ||
                           document.querySelector('button[name="add"]');
    
    console.log('Found button:', addToCartButton);
    
    if (addToCartButton) {
      const buttonRect = addToCartButton.getBoundingClientRect();
      console.log('Button rect:', buttonRect);
      
      // Position the toast near the button
      message.style.position = 'fixed';
      message.style.top = `${buttonRect.top + (buttonRect.height / 2) - 30}px`;
      message.style.right = '20px';
      message.style.zIndex = '9999';
      
      document.body.appendChild(message);
      console.log('Toast appended to body');
      
      // Trigger slide-in animation
      setTimeout(() => {
        message.classList.add('show');
        console.log('Toast show class added');
      }, 10);
      
      // Auto-remove after 3 seconds
      setTimeout(() => {
        message.classList.add('hide');
      setTimeout(() => {
        message.remove();
          console.log('Toast removed');
        }, 300); // Allow fade-out animation to complete
      }, 3000);
    } else {
      console.warn('Add to cart button not found, falling back to simple display');
      // Fallback: just append to body with default positioning
      message.style.position = 'fixed';
      message.style.top = '20px';
      message.style.right = '20px';
      message.style.zIndex = '9999';
      
      document.body.appendChild(message);
      
      setTimeout(() => {
        message.classList.add('show');
      }, 10);
      
      setTimeout(() => {
        message.classList.add('hide');
        setTimeout(() => {
          message.remove();
        }, 300);
      }, 3000);
    }
  }
  
  // Helper function to convert decimal to fraction
  decimalToFraction(decimal) {
    if (decimal >= 1) {
      return Math.floor(decimal).toString();
    }
    
    // Common fractions for carton sizes
    const fractions = {
      0.25: '1/4',
      0.5: '1/2',
      0.75: '3/4'
    };
    
    return fractions[decimal] || decimal.toString();
    }

  updateMediaGalleryForSelectedVariant() {
    // Get the correct variant ID based on current selections
    const pricingKey = this.getPricingKey();
    const quantityKey = String(this.selectedQuantity);
    const variantId = this.variantMapping[pricingKey]?.[quantityKey];
    
    if (!variantId) {
      console.log('No variant ID found for:', pricingKey, quantityKey);
      return;
    }

    console.log('Updating for variant ID:', variantId);
    
    // Update variant ID input
    const variantIdInputs = document.querySelectorAll('input[name="id"]');
    variantIdInputs.forEach(input => {
      input.value = variantId;
      console.log('Updated variant input to:', variantId);
    });

    // Update URL
    const currentUrl = new URL(window.location);
    currentUrl.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', currentUrl.toString());
    console.log('Updated URL variant to:', variantId);
    
    // Find the variant's featured media and switch to it
    this.switchToVariantMedia(variantId);
    
    // Trigger a change event on the variant input to let Shopify know
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput) {
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  
  switchToVariantMedia(variantId) {
    try {
      // Get product data
      const productScript = document.querySelector(`script[id^="ProductJSON-"]`);
      if (!productScript) {
        console.log('No product data script found');
        return;
      }
      
      const productData = JSON.parse(productScript.textContent);
      const variant = productData.variants?.find(v => v.id == variantId);
      
      if (!variant || !variant.featured_media?.id) {
        console.log('No variant or featured media found for:', variantId);
        return;
      }
      
      console.log('Switching to media ID:', variant.featured_media.id, 'for variant:', variant.title);
      
      // Find the media gallery component
      const mediaGallery = document.querySelector('media-gallery');
      if (!mediaGallery) {
        console.log('Media gallery component not found');
        return;
      }
      
      // Get the section ID from the media gallery
      const sectionId = mediaGallery.dataset.sectionId;
      const targetMediaId = `${sectionId}-${variant.featured_media.id}`;
      
      console.log('Looking for media with ID:', targetMediaId);
      
      // Find the thumbnail with the matching data-target
      const thumbnail = document.querySelector(`[data-target="${targetMediaId}"]`);
      if (thumbnail) {
        const button = thumbnail.querySelector('button');
        if (button) {
          console.log('Found thumbnail button, clicking it');
          button.click();
          return;
        }
      }
      
      // Fallback: directly call setActiveMedia if thumbnail click didn't work
      console.log('Thumbnail not found, using direct media switching');
      if (mediaGallery.setActiveMedia) {
        mediaGallery.setActiveMedia(targetMediaId, false);
      } else {
        // Manual fallback
        this.manualMediaSwitch(targetMediaId);
      }
      
    } catch (error) {
      console.error('Error switching variant media:', error);
    }
  }
  
  manualMediaSwitch(targetMediaId) {
    console.log('Manual media switch to:', targetMediaId);
    
    // Remove active from all media items
    const allMediaItems = document.querySelectorAll('.product__media-item');
    allMediaItems.forEach(item => {
      item.classList.remove('is-active');
    });
    
    // Add active to target media item
    const targetMediaItem = document.querySelector(`[data-media-id="${targetMediaId}"]`);
    if (targetMediaItem) {
      targetMediaItem.classList.add('is-active');
      console.log('Manually activated media item:', targetMediaId);
      
      // Also update thumbnails
      const allThumbnails = document.querySelectorAll('[data-target] button');
      allThumbnails.forEach(btn => {
        btn.removeAttribute('aria-current');
        btn.parentElement.classList.remove('is-active');
      });
      
      const targetThumbnail = document.querySelector(`[data-target="${targetMediaId}"]`);
      if (targetThumbnail) {
        const button = targetThumbnail.querySelector('button');
        if (button) {
          button.setAttribute('aria-current', 'true');
          targetThumbnail.classList.add('is-active');
        }
      }
    } else {
      console.log('Target media item not found:', targetMediaId);
    }
  }

  checkCartAddSuccess() {
    const successFlag = localStorage.getItem('cartAddSuccess');
    if (successFlag === 'true') {
      localStorage.removeItem('cartAddSuccess');
      this.showMessage('Added to cart successfully!', 'success');
    }
  }

  preventAutoScroll() {
    // More comprehensive scroll prevention following ChatGPT recommendation
    
    // 1. Override scrollIntoView temporarily during variant changes
    const originalScrollIntoView = Element.prototype.scrollIntoView;
    let preventScrolling = false;
    
    const blockScrollIntoView = () => {
      preventScrolling = true;
      Element.prototype.scrollIntoView = () => {}; // Block all scrollIntoView calls
      
      // Re-enable after a short delay
      setTimeout(() => {
        Element.prototype.scrollIntoView = originalScrollIntoView;
        preventScrolling = false;
      }, 500);
    };
    
    // 2. Prevent scroll on variant option changes (universal fix)
    document.querySelectorAll('[name="options"] select, [name="options"] input').forEach(el => {
      el.addEventListener('change', (e) => {
        blockScrollIntoView();
        
        // Prevent URL-based auto-scroll
        const url = new URL(window.location);
        url.searchParams.set(el.name, el.value);
        history.replaceState({}, '', url);
      });
    });
    
    // 3. Prevent scroll on our custom buttons
    const buttons = document.querySelectorAll('.size-btn, .print-type-btn, .lids-pill, .turnaround-pill');
    buttons.forEach(button => {
      button.addEventListener('click', (e) => {
        blockScrollIntoView();
        // Don't prevent default here as it would break functionality
      });
    });
    
    // 4. Intercept variant form changes
    const variantSelects = document.querySelector('variant-selects');
    if (variantSelects) {
      variantSelects.addEventListener('change', () => {
        blockScrollIntoView();
      });
    }
  }
}

// Smooth scroll to shipping calculator function
function scrollToShippingCalculator(event) {
  event.preventDefault();
  
  const shippingCalculator = document.getElementById('shipping-calculator');
  if (shippingCalculator) {
    shippingCalculator.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}

// Smooth scroll to ETA calculator section function
function scrollToEtaCalculator(event) {
  event.preventDefault();
  
  const etaCalculatorSection = document.getElementById('eta-calculator-section');
  if (etaCalculatorSection) {
    etaCalculatorSection.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}

// Legacy function for backwards compatibility
function scrollToDesignUpload(event) {
  event.preventDefault();
  
  const designUploadSection = document.getElementById('design-upload-section');
  if (designUploadSection) {
    designUploadSection.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}

// Test function for toast notification
function testToast() {
  if (window.coffeeCupProduct) {
    window.coffeeCupProduct.showMessage('Test toast message!', 'success');
  } else {
    console.error('CoffeeCupProduct not found');
  }
}

// Force bold function for dropdown titles
function forceBoldTitles() {
  console.log('Running forceBoldTitles...');
  
  // Find all dropdown titles
  const allTitles = document.querySelectorAll('.dropdown-title, .description-title');
  console.log('Found titles:', allTitles.length);
  
  allTitles.forEach((title, index) => {
    console.log(`Making title bold: ${title.textContent.trim()}`);
    
    // Use regular bold font-weight without text-shadow
    title.style.setProperty('font-weight', 'bold', 'important');
    title.classList.add('force-bold');
  });
  
  // NOW MAKE VARIANT SELECTOR TITLES BLACK
  const variantLabels = document.querySelectorAll('.form__label');
  console.log('Found variant labels:', variantLabels.length);
  
  variantLabels.forEach((label, index) => {
    console.log(`Making variant label black: ${label.textContent.trim()}`);
    label.style.setProperty('color', '#000000', 'important');
    label.style.setProperty('font-weight', 'bold', 'important');
  });
  
  // MAKE MAIN PRODUCT TITLE BLACK
  const mainProductTitle = document.querySelector('.product__title h1');
  if (mainProductTitle) {
    console.log(`Making main product title black: ${mainProductTitle.textContent.trim()}`);
    mainProductTitle.style.setProperty('color', '#000000', 'important');
  }
  
  // MAKE PRODUCT TAGLINE BLACK
  const productTagline = document.querySelector('.product-tagline');
  if (productTagline) {
    console.log(`Making product tagline black: ${productTagline.textContent.trim()}`);
    productTagline.style.setProperty('color', '#000000', 'important');
  }
  
  // Add CSS rule if it doesn't exist
  if (!document.querySelector('#force-bold-style')) {
    const style = document.createElement('style');
    style.id = 'force-bold-style';
    style.textContent = `
      .force-bold, .dropdown-title, .description-title {
        font-weight: 700 !important;
      }
      .form__label {
        color: #000000 !important;
        font-weight: bold !important;
      }
      .product__title h1 {
        color: #000000 !important;
      }
      .product-tagline {
        color: #000000 !important;
      }
    `;
    document.head.appendChild(style);
    console.log('Added force-bold CSS rule');
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const pricingTable = document.getElementById('quantity-grid-body');
  const sizeButtons = document.querySelectorAll('.size-btn');
  
  if (pricingTable && sizeButtons.length > 0) {
    new NapkinsProduct();
  }
});
